module.exports = __webpack_public_path__ + "media/icons/arrow-left-7113fdc55d0061a37659c0b8028f5683.svg";